var app;
(function ($) {
    $(document).ready(function () {
        app = {
            map: {
                map: null,
                markers: []
            },
            timeout: 600,
            varTimeout: null,
            isMobile: false,
            isTablet: false,
            isMaxTablet: false,
            breakPointMaxTablet: 1199,
            breakPointTablet: 992,
            breakPointMobile: 768,
            allCountries: [],
            init: function () {
                app.handleResize();
                app.responsiveDetection();
                app.showModal();
                app.initCustomSelectField();
                app.initCustomFileField();
                app.initSwiperHomepage();
                app.anchors();
                app.mapSvg();
                app.menu();
                app.togglePasswordVisibility();
                app.pwdValidation();
                app.initSearchBarCareer();
                app.accessibilty();
                app.initSearchBarCareerMobile();
                app.initLightboxes();
                app.handleDropdown();
                app.initFormBusiness();
                app.initGraphs();
                app.buttonMobile();
                app.initCustomScrollbar();
                app.passwordStrength();
                app.formGeneralError();
                app.loadMoreLocals();
                app.cookies();
                app.initChips();
                app.initPodcasts();
                app.initVideoBanner();
                app.initCollapseSearchBarV2();
                app.sendUtmToSR();
                // Initialize
                var bLazy = new Blazy();
                //
                if (window.location.search != "" && $("#form-filter-offers").length > 0) {
                    setTimeout(function (e) {
                        var _top = $("#form-filter-offers").offset().top;
                        if ($(window).scrollTop() > 0) {
                            _top = _top - $("#masthead").outerHeight();
                        } else {
                            _top = _top - ($("#masthead").outerHeight() * 2);
                        }
                        window.scrollTo({
                            top: _top,
                            behavior: 'smooth'
                        });
                    }, 300);
                }
            },
            cookies: function() {
                // BTN Accept all cookies
                $('a[href="#acceptAll"]').on("click", function(e) {
                    if( typeof(tarteaucitron) != "undefined" ) {
                        tarteaucitron.userInterface.respondAll(true);
                        tarteaucitron.userInterface.openPanel();
                    }
                    e.preventDefault();
                    return false;
                });
                // BTN Refuse all cookies
                $('a[href="#denyAll"]').on("click", function(e) {
                    if( typeof(tarteaucitron) != "undefined" ) {
                        tarteaucitron.userInterface.respondAll(false);
                        tarteaucitron.userInterface.openPanel();
                    }
                    e.preventDefault();
                    return false;
                });
            },
            sendUtmToSR: function() {
                // Check GTM cookie acceptance
                function readCookie(name) {
                    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
                    return match ? match[2] : null;
                }

                function isGoogleTagManagerEnabled() {
                    const cookieValue = readCookie('assystemcorpo_tac');
                    if (cookieValue) {
                        const values = cookieValue.split('!');
                        for (let i = 0; i < values.length; i++) {
                            const [key, value] = values[i].split('=');
                            if (key === 'googletagmanager' && value === 'true') {
                                return true;
                            }
                        }
                    }
                    return false;
                }

                function getUTMParameters() {
                    const urlParams = new URLSearchParams(window.location.search);
                    const utmParams = {};
                    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach(param => {
                        if (urlParams.has(param)) {
                            utmParams[param] = urlParams.get(param);
                        }
                    });
                    return utmParams;
                }

                function storeUTMParameters(params) {
                    if (Object.keys(params).length > 0) {
                        localStorage.setItem('utmParams', JSON.stringify(params));
                    }
                }

                const utmParams = getUTMParameters();
                storeUTMParameters(utmParams);

                document.querySelectorAll('.btn-job-apply').forEach(button => {
                    button.addEventListener('click', event => {
                        // Reactive if RGPD issues for storing GTM vars
                        // if (isGoogleTagManagerEnabled()) {
                        const storedParams = JSON.parse(localStorage.getItem('utmParams'));
                        if (storedParams) {
                            const url = new URL(button.href);
                            Object.keys(storedParams).forEach(param => {
                                url.searchParams.set(param, storedParams[param]);
                            });
                            button.href = url.toString();
                        }
                        // }

                    });
                });
            },
            loadMoreLocals: function() {
                let currentPage = 6;
                $('#load-more').on('click', function(e) {
                    let _this       =   $(this),
                        _parent     =   _this.parents(".ctas-center"),
                        country_id  =   _this.data("target");
                    _parent.addClass("loading");


                    $.ajax({
                        type: 'POST',
                        url: '/wp-admin/admin-ajax.php',
                        dataType: 'html',
                        data: {
                            action: 'locals_load_more',
                            paged: currentPage,
                            country_id: country_id
                        },
                        success: function (res) {
                            $('.addresses-country').append(res);
                            _parent.removeClass("loading");
                            $('#load-more').hide();
                        }
                    });
                    e.preventDefault();
                    return false;
                });
            },
            exist: function (querry) {
                var element = document.querySelector(querry);
                if (typeof (element) != 'undefined' && element != null) {
                    return true
                }
            },
            buttonMobile: function () {
                var _burger = $('.button-menu'),
                    _primary= $("#primary"),
                    _footer = $("#colophon");
                if (_burger.length > 0) {
                    _burger.on('click', function () {
                        var _this = $(this);
                        if (_this.attr("aria-expanded") == "false") {
                            _this.attr("aria-expanded", "true");
                            _primary.attr("tabindex", "-1");
                            _footer.attr("tabindex", "-1");
                        } else {
                            _primary.removeAttr("tabindex");
                            _footer.removeAttr("tabindex");
                            _this.attr("aria-expanded", "false");
                        }
                        $('body').toggleClass('menu-open');
                        $(".main-navigation").toggleClass("active");
                    })
                }
            },
            initCustomScrollbar: function () {
                if ($('.custom-scrollbar').length > 0) {
                    $('.custom-scrollbar').each(function () {
                        new SimpleBar($(this)[0], {
                            autoHide: false
                        });
                    })
                }
            },
            initGraphs: function () {
                //Resize graph depending on screensize / historique graph
                $('.graph-year-menu').on('click', 'a', function (e) {
                    var year = $(this).data('year');
                    $('.histo-graph').attr('src', 'https://gateway.euronext.com/charts/history.gif?PROFILE=blue&FILLED=true&INSTRUMENT=FR0000074148*XPAR*ISIN&STARTDATE=&ENDDATE=&PERIOD=' + year + 'Y&ADD_DAY_LAST_PRICE=true&COMP=&DATA_TYPE=PX&ADD_INFO=&QUALITY=RT&WIDTH=820&HEIGHT=320&authKey=ae22289fc7275f246a6040bc1496afc64334b4b2d102e24d2a2a38964eae909a');
                    e.preventDefault();
                    return false;
                });
            },
            handleDropdown: function () {
                var dropdownLinks = $('.nav-item__dropdownLink');
                dropdownLinks.on("click", function (e) {
                    var _this = $(this),
                        _list = _this.parent().find(".nav-item__dropdownList").first();
                    if (app.isMaxTablet) {
                        _list.addClass("active");
                        _this.attr("aria-expanded", true);
                        e.preventDefault();
                        return false;
                    }
                });
                $(".nav-item__dropdownList__close").on("click", function (e) {
                    $(this).parent().parent().removeClass("active");
                    $(this).parent().parent().prev().attr("aria-expanded", false);
                    e.preventDefault();
                    return false;
                });
            },
            initLightboxes: function () {
                if ($('[data-toggle="lightbox"]').length > 0) {
                    $(document).on('click', '[data-toggle="lightbox"]', function (event) {
                        event.preventDefault();
                        $(this).ekkoLightbox({
                            alwaysShowClose: true
                        });
                    });
                }
            },
            handleResize: function () {
                $(window).on('resize', function () {
                    app.responsiveDetection();
                });
            },
            responsiveDetection: function () {
                app.isMobile = $(window).width() < app.breakPointMobile;
                app.isTablet = $(window).width() < app.breakPointTablet;
                app.isMaxTablet = $(window).width() <= app.breakPointMaxTablet;
            },
            showModal: function () {
                if ($('.modal').data('display') === true) {
                    $('.modal').modal('show')
                }
            },
            initSwiperHomepage: function () {
                if ($('.banner-slider_swiper').length > 0 && $('.banner-slider_swiper').find('.banner-slider_item').length > 1) {
                    // return Text Pagination
                    app.BannerHomepagePagination = [];
                    $('.banner-slider_swiper').find('.banner-slider_item').each(function (index, element) {
                        let labels = {};
                        var _title = $(element).attr("data-title-pagination"),
                            _text = $(element).attr("data-desc-pagination"),
                            _class = $(element).attr("data-class");
                        labels.title = _title;
                        labels.text = _text;
                        labels.class = _class;
                        app.BannerHomepagePagination.push(labels);
                    });

                    const BannerHomepageSwiper = new Swiper('.banner-slider_swiper', {
                        speed: 400,
                        slidesPerView: 1,
                        spaceBetween: 0,
                        preloadImages: false,
                        lazy: true,
                        a11y: false,
                        pagination: {
                            el: '.banner-slider_pagination-wrapper .banner-slider_pagination',
                            clickable: true,
                            renderBullet: function (index, className) {
                                return '<li class="' + className + ' ' + (app.BannerHomepagePagination[index].class) + '"><buton><span class="title">' + (app.BannerHomepagePagination[index].title) + '</span> ' + (app.BannerHomepagePagination[index].text) + '</buton></li>';
                            },
                        },
                        navigation: false,
                        // Responsive breakpoints
                        breakpoints: {
                            991: {
                                slidesPerView: 1,
                                spaceBetween: 0,
                            }
                        }
                    });
                }
            },
            initCustomSelectField: function () {
                if ($('.custom-form').length > 0) {
                    // SINGLES
                    const _customSelectSingleTransparent = $('.custom-form').find('.js-custom-single-transparent');
                    _customSelectSingleTransparent.each(function () {
                        $(this).select2({
                            placeholder: $(this).data('placeholder') && $(this).data('placeholder').length ? $(this).data('placeholder') : "",
                            allowClear: false,
                            theme: "style-2",
                            dropdownParent: $(this).parent()
                        });
                    });
                    const _customSelectSingleWhite = $('.custom-form').find('.js-custom-single-white');
                    _customSelectSingleWhite.each(function () {
                        $(this).select2({
                            placeholder: $(this).data('placeholder') && $(this).data('placeholder').length ? $(this).data('placeholder') : "",
                            allowClear: false,
                            theme: "style-1",
                            dropdownParent: $(this).parent()
                        });
                    });

                    // MULTIPLES
                    const _customSelectMultipleTransparent = $('.custom-form').find('.js-custom-multiple-transparent');
                    _customSelectMultipleTransparent.each(function () {
                        $(this).select2({
                            placeholder: $(this).data('placeholder') && $(this).data('placeholder').length ? $(this).data('placeholder') : "",
                            allowClear: false,
                            theme: "style-2",
                            dropdownParent: $(this).parent(),
                            closeOnSelect: false
                        });
                    });
                    const _customSelectMultipleWhite = $('.custom-form').find('.js-custom-multiple-white');
                    _customSelectMultipleWhite.each(function () {
                        $(this).select2({
                            placeholder: $(this).data('placeholder') && $(this).data('placeholder').length ? $(this).data('placeholder') : "",
                            allowClear: false,
                            theme: "style-1",
                            dropdownParent: $(this).parent(),
                            closeOnSelect: false
                        });
                        $(this).on("select2:open", function (e) {
                            let optionsContainer = $('.select2-results__options').get(0);
                            setTimeout(function () {
                                new SimpleBar(optionsContainer, {
                                    autoHide: false
                                });
                            }, 0);
                        });
                    });
                }
                //
                var _customMultipleSelect   =   $(".custom-select-multiple"),
                    _selectFrance           =   $("#select-france");
                // CLICK ON PAYS (master - level 1)
                _customMultipleSelect.on("click", "#select2-select-france-results .simplebar-content>.select2-results__option", function(e) {
                    var _this           =   $(this),
                        _index          =   _this.index(),
                        _is_selected    =   _this.hasClass("select2-results__option--selected"),
                        _has_children   =   _this.next().hasClass("select2-results__option--group");
                    if( _has_children ) {
                        if( _is_selected ) {
                            var _children   =   _this.next(),
                                _selected   =   _children.find(".select2-results__option--selected");//select-france
                            // Unselect children
                            _selected.map(function(i, el) {
                                _selected.removeClass("select2-results__option--selected");
                                _selectFrance.children().eq((_index+1)).children($(el).index()).prop("selected", false);
                                _selectFrance.trigger("change");
                            });
                        }
                    }
                });
                // CLICK ON REGIONS (children - level 2)
                _customMultipleSelect.on("click", "#select2-select-france-results .select2-results__options--nested .select2-results__option", function(e) {
                    var _this       =   $(e.target),
                        _index      =   _this.index(),
                        _has_parent =   _this.parents(".select2-results__option"),
                        _is_selected=   _this.hasClass("select2-results__option--selected");
                    if( _has_parent.length > 0 ) {
                        if( _is_selected ) {
                            var _parent     =   _this.parents(".select2-results__option--group").prev(),
                                _parentText =   _parent.text(),
                                _parentIndex=   _parent.index();
                            if( _parent.hasClass("select2-results__option--selected") ) {
                                _parent.removeClass("select2-results__option--selected");
                                _selectFrance.children().eq(_parentIndex).prop("selected", false);
                                _selectFrance.trigger("change");
                            }
                        }
                    }
                });
                $("input:checkbox.uniform").on("change", function (e) {
                    var _this = $(this),
                        _parent = _this.parents(".list-group-item").first(),
                        _state = _this.is(":checked");
                    if (_state) {
                        if (_parent.hasClass("has-children")) {
                            _parent.find(".collapse input:checkbox").prop({checked: false}).uniform().change();
                        }
                        if (_parent.hasClass("has-parent")) {
                            _parent.parents(".list-group-item.has-children").find(".collpase-wrap input:checkbox").prop({checked: false}).uniform().change();
                        }
                    }
                });
                $("input:checkbox.styled-checkbox").on("change", function (e) {
                    var _this = $(this),
                        _parent = _this.parents(".list-group-item").first(),
                        _state = _this.is(":checked");
                    if (_state) {
                        if (_parent.hasClass("has-children")) {
                            _parent.find(".collapse input:checkbox").prop({checked: false}).change();
                        }
                        if (_parent.hasClass("has-parent")) {
                            _parent.parents(".list-group-item.has-children").find(".collpase-wrap input:checkbox").prop({checked: false}).change();
                        }
                    }
                });
            },
            dynamicSelects: function () {
                if ($('.custom-form').length > 0) {
                    // SINGLES
                    const _customSelectSingleTransparent = $('.custom-form').find('.js-custom-single-transparent:not(.select2-hidden-accessible)');
                    _customSelectSingleTransparent.each(function () {
                        $(this).select2({
                            placeholder: $(this).data('placeholder') && $(this).data('placeholder').length ? $(this).data('placeholder') : "",
                            allowClear: false,
                            theme: "style-2",
                            dropdownParent: $(this).parent()
                        });
                    });
                }
            },
            initCustomFileField: function () {
                if ($('.custom-file').length > 0) {
                    var inputs = document.querySelectorAll('.inputfile');
                    Array.prototype.forEach.call(inputs, function (input) {
                        var label = input.nextElementSibling,
                            labelVal = label.innerHTML;
                        input.addEventListener('change', function (e) {
                            var deleteLink = e.target.parentNode.getElementsByClassName('delete-file')[0];
                            var labelBase = e.target.parentNode.getElementsByClassName('label-base')[0];
                            deleteLink.classList.add('show');
                            labelBase.classList.add('screen-reader-text');
                            var fileName = '';
                            if (this.files && this.files.length > 1)
                                fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
                            else
                                fileName = e.target.value.split('\\').pop();

                            if (fileName)
                                label.querySelector('span.text').innerHTML = fileName;
                            else
                                label.innerHTML = labelVal;
                        });

                        // Firefox bug fix
                        input.addEventListener('focus', function () {
                            input.classList.add('has-focus');
                        });
                        input.addEventListener('blur', function () {
                            input.classList.remove('has-focus');
                        });
                    });
                    $('.delete-file').on('click', function (e) {
                        $(this).parents('.box').find('.label-base').removeClass('screen-reader-text');
                        $(this).parents('.box').find('.text').text('');
                        $(this).removeClass('show');
                        if ($(this).parent().find('.file-deleted').length > 0) {
                            $(this).parent().find('.file-deleted').removeAttr('value');
                        }
                        e.preventDefault();

                    });
                }
            },
            anchors: function () {
                if ($('.block-anchors').length > 0) {
                    let top = parseInt($('.block-anchors').offset().top) - 150;
                    $('body').on('scroll', function () {
                        if ($(this).scrollTop() > top) {
                            $('.block-anchors').addClass("sticky");
                        } else {
                            $('.block-anchors').removeClass("sticky");
                        }
                    });
                    $('.block-anchors .anchor').on('click', function (e) {
                        $('.block-anchors .anchor').removeClass('active');
                        $(this).addClass(('active'));
                        var _anchorValue = $(this).find('.anchor-link').data('anchor');
                        if (typeof (_anchorValue) != "undefined") {
                            window.scrollTo({
                                top: ($('#' + _anchorValue).offset().top),
                                behavior: 'smooth'
                            });
                            e.preventDefault();
                        }
                    });
                }
            },
            handleTabChange: function () {
                if ($('.block-maps').length > 0) {
                    $('.indicator').css({
                        width: $('.nav-link.active').outerWidth(),
                        left: $('.nav-link.active').position().left
                    });
                    $('a[data-toggle="tab"]').on('shown.bs.tab', function (event) {
                        event.target; // newly activated tab
                        event.relatedTarget; // previous active tab
                        $('.indicator').css({
                            width: $(event.target).outerWidth(),
                            left: $(event.target).position().left
                        });
                    });
                }
            },
            initSearchBarCheckbox: function () {
                // Checkbox on check - Uncheck child and parent checkboxes
                $(document).on('change', '[data-has-children], [data-has-parent]', function () {
                    var children = $(this).closest('.collpase-wrap').next('.collapse').find('input'),
                        parent = $(this).parents('.collapse').prev('.collpase-wrap').find('input');
                    if (this.checked) {
                        children.prop({checked: false}).uniform().change();
                        parent.prop({checked: false}).uniform().change();
                    }
                });
            },
            accessibilty: function () {
                $('#searchForm').on('show.bs.collapse', function () {
                    $(this).attr('aria-hidden', 'false');
                    $(this).find("[tabindex='-1']").each(function () {
                        $(this).attr('tabindex', 0);
                    })
                });
                $('#searchForm').on('hidden.bs.collapse', function () {
                    $(this).attr('aria-hidden', 'true');
                    $(this).find("[tabindex='0']").each(function () {
                        $(this).attr('tabindex', -1);
                    })
                });
                $('#dropdownMenuLink').dropdown();
                $('#toggleMenuUser').dropdown();

                var _opener =   $(".opener");
                if ( _opener.length > 0 ) {
                    _opener.on("click", function(e) {
                        var _this   =   $(this),
                            attr    = $(this).attr('aria-expanded');
                        if (typeof attr !== 'undefined' && attr !== false) {
                            if( attr == "false" ) {
                                _this.attr("aria-expanded", true);
                            } else {
                                _this.attr("aria-expanded", false);
                            }
                        }
                    });
                }

                if( $(".wpcf7-form #cgv").length > 0 ) {
                    $(".wpcf7-form #cgv").on("change", function(e){
                        var _this   =   $(this);
                        if( _this.is(":checked") ) {
                            _this.attr("aria-invalid", false);
                        } else {
                            _this.attr("aria-invalid", true);
                        }
                    });
                }
            },
            initSearchBarCareer: function () {
                $("#offers-filter-inner .card .opener").on("click", function (e) {
                    var _this = $(this),
                        _card = _this.parents(".card").first();
                    if (_card.hasClass("active")) {
                        _card.removeClass("active");
                    } else {
                        $(".card").removeClass("active");
                        _card.addClass("active");
                    }
                    e.preventDefault();
                    return false;
                });

                $("#offers-filter-inner .card input").on('focus', function (e) {
                    $(this).parents('.checker').addClass('focus');
                });

                $("#offers-filter-inner .card input").on('focusout', function (e) {
                    $(this).parents('.checker').removeClass('focus');
                });

                $(document).on("click", function (e) {
                    if ($(e.target).parents(".list-group").length == 0 && $(e.target).parents("#offers-filter-inner").length == 0) {
                        $("#offers-filter-inner .card").removeClass("active");
                    }
                });
            },
            initSearchBarCareerMobile: function () {
                $(".mobile-open-filters a").on("click", function (e) {
                    var _this = $(this),
                        _parent = _this.parent();
                    if (_parent.hasClass("active")) {
                        _parent.removeClass("active");
                    } else {
                        _parent.addClass("active");
                    }
                    e.preventDefault();
                    return false;
                });
            },
            mapSvg: function () {
                if ($('.block-maps').length > 0) {
                    let mapCountries = $('.map-countries'),
                        map = mapCountries.find('svg'),
                        tooltipAllowed = false,
                        implantations = $('.block-maps .map-countries_continents li');
                    app.highlightAll(map);
                    $('.indicator').css({
                        width: $('.block-maps .map-countries_continents li.active').outerWidth(),
                        left: $('.block-maps .map-countries_continents li.active').position().left
                    });
                    implantations.on('keyup', function (e) {
                        if (e.which === 13) {
                            $(this).trigger('click');
                        }
                    });
                    // Implantations on click
                    implantations.on('click', function () {

                        var _split = $(this).data('coordinates').split(' '),
                            _zoom = $(this).data('zoom'),
                            _continent = $(this).data('continent'),
                            _active = mapCountries.find('.active');

                        map.css('transform', 'translate(' + _split[0] + ',' + _split[1] + ') scale(' + _zoom + ')');

                        _active.removeClass('active');
                        implantations.removeClass('active');
                        $(this).addClass('active');

                        $('.indicator').css({
                            width: $(this).outerWidth(),
                            left: $(this).position().left
                        });

                        switch (_continent) {
                            case 'europe' :
                                app.hightlightCountries('europe');
                                break;
                            case 'inde' :
                                app.hightlightCountries('inde');
                                break;
                            case 'asie-pacifique' :
                                app.hightlightCountries('asie-pacifique');
                                break;
                            case 'afrique-moyen-orient' :
                                app.hightlightCountries('afrique-moyen-orient');
                                break;
                            default:
                                break;
                        }

                        // Highlight all when map is full
                        _zoom === 1 && app.highlightAll(map);
                    });

                    // Continents on hover
                    map.find('g, polygon, path').on('mousemove', function (e) {
                        var _tooltip = mapCountries.find('.tooltip'),
                            _h = _tooltip.height(),
                            _w = _tooltip.outerWidth();
                        _tooltip.css({'top': (e.clientY - 40), 'left': (e.clientX - (_w / 2))});
                    });

                    map.find('g, polygon, path').on('mouseover', function (e) {
                        var _pathId = this.id;
                        if (_pathId && $(this).hasClass('active')) {
                            tooltipAllowed = true;
                            var text = $(this).data('name') ? $(this).data('name').replace(/[0-9]/g, '') : this.id.replace(/[0-9]/g, '');

                            var locals = window.countriesInfos.locals;

                            $(locals).each(function () {
                                if (this.country_slug.includes(_pathId)) {
                                    text = this.name;
                                }
                            });
                            var tooltip = '<div class="tooltip">' +
                                '<p>' + text + '</p>' +
                                '</div>';

                            if (mapCountries.find('.tooltip').length === 0) {
                                mapCountries.append(tooltip);
                            } else {
                                mapCountries.find('.tooltip p').text(text)
                            }
                            mapCountries.find('.tooltip').css('opacity', '1');
                        }
                    });

                    // Hide tooltip on leave
                    map.find('g, polygon, path').on('mouseleave', function () {
                        var _tooltip = mapCountries.find('.tooltip');
                        _tooltip.css('opacity', '0').removeAttr('style');
                    });

                    // Continents on click
                    map.find('g, polygon, path').on('click', function () {
                        var origin = window.location.origin;
                        var _el = this,
                            _link = $(_el).attr("data-link");
                        if (typeof (_link) != "undefined" && _link != "") {
                            window.location.assign($(_el).attr("data-link"));
                        }
                    });

                }
            },
            highlightAll: function (map) {
                map.find('g, polygon, path').each(function () {
                    let __this = $(this),
                        item = this;
                    if (this.id !== '') {
                        app.allCountries.push(this);
                        let locals = window.countriesInfos.locals,
                            isFound = false;
                        $(locals).each(function () {
                            if (this.country_slug.includes(item.id)) {
                                __this.addClass('active');
                                $(item).attr('data-link', this.redirection);
                                isFound = true;
                            }
                        });

                        if (!isFound) {
                            $(item).addClass("off");
                        }

                    } else {
                        $(item).addClass("off");
                    }
                });

            },
            hightlightCountries: function (continent) {
                var locals = window.countriesInfos.locals;
                $(locals).each(function () {
                    if (this.continent === continent) {
                        var _item = this;
                        $(app.allCountries).each(function () {
                            // For countries with multiple parts
                            $(this).data('name') && _item.country_slug === $(this).data('name') && $(this).addClass('active');
                            _item.country_slug === this.id && $(this).addClass('active');
                        })
                    }
                });
            },
            pwdValidation: function () {
                /**
                 * Password Validation
                 */
                var valPwdTimeout = null;
                $(document).on('change keyup', '[data-bind-strength]', function () {
                    var _this = $(this),
                        pwd = _this.val(),
                        // strength = 1,
                        strMeterEL = $($(this).attr('data-bind-strength')),
                        progressBar = strMeterEL.find('.progress-bar'),
                        //strMsgEl = strMeterEL.find('.strength'),
                        strClass = ['bg-danger', 'bg-warning', 'bg-info', 'bg-primary', 'bg-success'];
                    //msgs = JSON.parse(strMsgEl.attr('data-texts'));
                    clearTimeout(valPwdTimeout);
                    valPwdTimeout = setTimeout(function () {
                        pwdStrength = 1;
                        if (pwd.length > 0) {
                            _this.closest('.form-group').removeClass('has-danger').find('.form-control-feedback').remove();
                            if (pwd.length < 5) { // Minimum 5 characters
                                pwdStrength = 1;
                                //_this.closest('.form-group').addClass('has-danger').append('<span class="form-control-feedback" role="alert">' + 'Mot de passe trop court'+'</span>');
                            } else {
                                if (pwd.length > 11) // More than 12 characters
                                    pwdStrength++;
                                if (/([a-z].*[A-Z])|([A-Z].*[a-z])/.test(pwd)) // Uppercase and lowercase letters
                                    pwdStrength++;
                                if (/([a-zA-Z0-9])/.test(pwd)) // Letters and numbers
                                    pwdStrength++;
                                if (/([\!\,\%\&\@\#\$\^\*\?\_\~\/+\.])/.test(pwd)) // Atleast 1 special character
                                    pwdStrength++;
                            }
                        }
                        //
                        // strMsgEl.text(msgs[pwdStrength - 1]);
                        progressBar.stop(true).animate({width: ((pwdStrength / 5) * 100) + '%'}).removeClass(strClass.join(' ')).addClass(strClass[pwdStrength - 1]).closest('.form-group').show();
                    }, 200);
                });

            },
            togglePasswordVisibility: function () {
                $('button[data-action="show-password"]').on('click', function () {
                    var elm = $(this).parent('.input-group-btn').children('input');
                    if (elm.attr('type') === 'password') {
                        elm.attr('type', 'text');
                    } else {
                        elm.attr('type', 'password');
                    }

                });
            },
            positionMainMenu: function () {
                let pad = parseInt($('#primary-menu > li:first-child').offset().left * 100 / parseInt($(window).width()));
                let top = parseInt($('.site-header').height());
                $('#primary-menu > .menu-item-has-children > .sub-menu').css({
                    'padding-left': pad + 'vw',
                    top: top + 'px'
                });
                $('#primary-menu > .menu-item-has-children > .sub-menu .sub-menu').css({
                    'width': 'calc(100% - 30vw - ' + pad + 'vw'
                });
            },
            resetMenu: function (brutal, target) {
                // console.log('resetMenu', brutal, target);
                let menuItem = $('.menu-item-has-children.level-0');
                let menuItemLvl1 = $('.menu-item-has-children.level-1');
                menuItemLvl1.removeClass("active");
                menuItemLvl1.find(".nav-item__dropdownLink").attr("aria-expanded", false);
                if (!brutal) {
                    menuItem.map(function (i, el) {
                        if ($(el).find(".sub-menu").is(":visible")) {
                            $(el).find('.sub-menu').clearQueue().stop().fadeOut(100, function () {
                                $(this).removeAttr("style");
                                menuItem.find('.menu-item-has-children').removeClass('active');
                                menuItem.find('.sub-menu').removeAttr("style");
                                menuItem.removeClass('active');
                                app.positionMainMenu();
                                $(this).parents(".level-0").blur();
                            });
                        }
                    });
                } else {
                    $('.menu-item-has-children.level-0:not(.active)').find('.nav-item__dropdownLink').attr("aria-expanded", false);
                    menuItem.find('.sub-menu').removeAttr("style");
                    menuItem.find('.menu-item-has-children').removeClass('active');
                    if( target != null ) {
                        menuItem.map(function(i, el){
                            if( $(el).attr("id") !== target.attr('id') ) {
                                $(el).removeClass('active');
                            }
                        });
                    } else {
                        menuItem.removeClass('active');
                    }
                    app.positionMainMenu();
                }
            },
            menu: function () {
                let top = parseInt($('.site-header').height());
                $(window).on('scroll', function () {
                    if ($(this).scrollTop() > top) {
                        $('.site-header').addClass("sticky");
                    } else {
                        $('.site-header').removeClass("sticky");
                    }
                });
                app.positionMainMenu();
                let menuItemLvl0 = $('.menu-item-has-children.level-0');
                let menuItemLvl1 = $('.menu-item-has-children.level-1');
                let menuLvl1 = $('.level-1');
                let menuItem = $('.menu-item-has-children');

                var _level0li       =    $(".level-0");
                var _level0buttons  =    $(".level-0>button.nav-item__dropdownLink");
                _level0buttons.on("click", function(e){
                    var _this   =   $(this),
                        _parent =   _this.parent(),
                        _isOn   =   _parent.hasClass("active");
                    _level0li.map(function(i, el) {
                        if( $(el).attr("id") !== _parent.attr("id") ) {
                            $(el).removeClass("active");
                        }
                    } );
                });
                var _level1buttons  =    $(".level-1>button.nav-item__dropdownLink");
                _level1buttons.on("click", function(e){
                    var _this   =   $(this),
                        _parent =   _this.parent();
                    if( !_parent.hasClass("active") ) {
                        menuLvl1.removeClass("active");
                        _parent.addClass("active");
                        _this.attr("aria-expanded", true);
                    } else {
                        // menuLvl1.removeClass("active");
                        _parent.addClass("toclose");
                        _this.attr("aria-expanded", false);
                    }
                });
                menuItem.bind('mouseover, click', function (e) {
                    clearTimeout(app.varTimeout);
                });
                menuItemLvl1.find(">a,>button").bind('click', function (e) {
                    if (app.isMaxTablet) {
                        var _this = $(this),
                            _li = _this.parent();
                        clearTimeout(app.varTimeout);
                        app.varTimeout = null;
                        if (_li.hasClass("level-1")) {
                            $(".level-1").removeClass("active");
                        }
                        if (!_li.hasClass('active')) {
                            _li.children('.sub-menu').clearQueue().stop().fadeIn(300).css({
                                display: 'flex',
                                visibility: 'visible'
                            });
                            _li.addClass('active');
                        }
                        if (_li.hasClass("level-1")) {
                            let maxHeight = _li.parent(".sub-menu").height();
                            _li.each(function (i, el) {
                                if (_li.children('.sub-menu').innerHeight() > maxHeight) {
                                    maxHeight = $(this).children('.sub-menu .sub-menu').innerHeight();
                                    _li.parents('.sub-menu').css({'min-height': maxHeight + 'px'});
                                }
                            });
                        }
                        e.preventDefault();
                        return false;
                    } else {
                        return true;
                    }
                });

                $("#primary-menu").on("keyup", function(e){
                    if( e.key === "Escape" || e.key === "Esc" ) {
                        var _parent = $(".level-0.active"),
                            _child  = $(".level-1.active");
                        if (_child.length !== 0) {
                            // level 1
                            _child.removeClass("active");
                            _child.find(".nav-item__dropdownLink").focus();
                            _child.find(".nav-item__dropdownLink").attr("aria-expanded",false);
                        } else {
                            // level 0
                            _parent.find(".nav-item__dropdownLink").attr("aria-expanded", false);
                            app.resetMenu(true, null);
                        }
                    }
                });
                menuItemLvl1.bind('click', function (e) {
                    if (!app.isMaxTablet) {
                        clearTimeout(app.varTimeout);
                        app.varTimeout = null;
                        let maxHeight = -1;
                        if (!$(this).hasClass('active')) {
                            $(this).children('.sub-menu').clearQueue().stop().fadeIn(300).css({
                                display: 'flex',
                                visibility: 'visible'
                            });
                            $(this).addClass('active');
                        }
                        if ($(this).children('.sub-menu .sub-menu').innerHeight() > maxHeight) {
                            maxHeight = $(this).children('.sub-menu .sub-menu').innerHeight();
                            $(this).parents('.sub-menu').css({'min-height': maxHeight + 'px'});
                        }
                        if( $(this).hasClass('toclose') ) {
                            $(this).removeClass("active");
                            $(this).removeClass("toclose");
                        }
                    }
                });
                menuItemLvl0.find(">a,>button").bind('click', function (e) {
                    var _this = $(this),
                        _li = _this.parent();
                    clearTimeout(app.varTimeout);
                    app.varTimeout = null;
                    if (_li.hasClass("level-0")) {
                        _li.focus();
                        app.resetMenu(true, _li);
                    }
                    if (_li.hasClass("level-1")) {
                        $(".level-1").removeClass("active");
                    }

                    if (!_li.hasClass('active')) {
                        _li.children('.sub-menu').clearQueue().stop().fadeIn(300).css({
                            display: 'flex',
                            visibility: 'visible'
                        });
                        _this.attr("aria-expanded", true);
                        _li.addClass('active');
                    } else {
                        // #19716 : add condition to fix on resize
                        if(_this.attr("aria-expanded") === false) {
                            _this.attr("aria-expanded", true);
                            _li.addClass('active');
                        } else {
                            _this.attr("aria-expanded", false);
                            _li.removeClass('active');
                        }
                    }
                    if (_li.hasClass("level-1")) {
                        let maxHeight = _li.parent(".sub-menu").height();
                        _li.each(function (i, el) {
                            if (_li.children('.sub-menu').innerHeight() > maxHeight) {
                                maxHeight = $(this).children('.sub-menu .sub-menu').innerHeight();
                                _li.parents('.sub-menu').css({'min-height': maxHeight + 'px'});
                            }
                        });
                    }
                });
                $(document).on("click", function (e) {
                    var _this = $(e.target);
                    if (_this.parents("#primary-menu").length == 0) {
                        $('.menu-item-has-children.level-0').removeClass("active");
                        app.resetMenu(true, null);
                    }
                });

                menuItem.find(">a,>button").bind("click", function (e) {
                    var _this = $(this),
                        _href = _this.attr("href"),
                        _modal = _this.data("toggle");
                    if (_href == "#" && typeof (_modal) == "undefined") {
                        e.preventDefault();
                        return false;
                    }
                });

                let langSelection = document.querySelectorAll('.sub-header-mobile .without-style ul li:not(.separator)');
                langSelection.forEach(function (elem) {
                    elem.addEventListener('click', function () {
                        let currentActive = document.querySelector('.sub-header-mobile .without-style ul li.active');
                        $(currentActive).removeClass("active");
                        $(elem).addClass("active");
                    })
                });
                //
                if ($(".sub-header .accessibility-menu").length > 0) {
                    // check bakhtech
                    var _ls = window.localStorage['settings'];
                    if (typeof (_ls) != "undefined") {
                        _ls = JSON.parse(_ls);
                        if (typeof (_ls.choix_profil) != "undefined" || typeof (_ls.choix_couleurs) != "undefined" || typeof (_ls.choix_police) != "undefined" || typeof (_ls.zoom_texte) != "undefined") {
                            app.addBakhtechPlugin(false);
                        }
                    }
                    var _btnBakhtech = $("#btn_open");
                    $(".accessibility-menu").on("click", function (e) {
                        // https
                        if (_btnBakhtech.length > 0) {
                            // _btnBakhtech.trigger("click");
                            window.bcOpenClose();
                        } else {
                            app.addBakhtechPlugin(true);
                        }
                        e.preventDefault();
                        return false;
                    });
                }
            },
            addBakhtechPlugin: function (force) {
                var s = document.createElement("script");
                s.async = true;
                s.defer = true;
                s.onload = function () {
                    if (force) {
                        setTimeout(function (e) {
                            window.bcOpenClose();
                        }, 100);
                    }
                };
                s.src = "//bakhtech.com/bakh-confort/js/toolbar.js";
                s.type = "text/javascript";
                document.head.appendChild(s);
            },
            initFormBusiness() {

                var _formSwitcher = $("#00N0J00000A6HsW");
                if (_formSwitcher.length > 0) {
                    _formSwitcher.on("change", function () {
                        var _partnersBlock = $(".partners-selected"),
                            _disabled = $(".disabled");
                        //
                        if (_formSwitcher[0].selectedIndex === 3) {
                            _partnersBlock.css('display', 'block');
                            if (!_disabled.hasClass("active")) {
                                _disabled.addClass("active");
                            }
                        }
                        if (_formSwitcher[0].selectedIndex === 0) {
                            _partnersBlock.css('display', 'none');
                            _disabled.removeClass("active");
                        }
                        if (_formSwitcher[0].selectedIndex !== 0 && _formSwitcher[0].selectedIndex !== 3) {
                            _partnersBlock.css('display', 'none');
                            if (!_disabled.hasClass("active")) {
                                _disabled.addClass("active");
                            }
                        }
                    });
                }
                var _form = $("#sf-form"),
                    _overlay = $('.overlay-send');
                if (_form.length > 0) {
                    _form.on("submit", function (e) {
                        var form = $(this),
                            _errors = false;
                        $(".alert-msg").removeClass("active").removeClass("error");
                        // ajax hide form
                        _overlay.addClass('show');
                        //
                        $(".sf-form-control.required").each(function (i, el) {
                            var _this = $(el);
                            if (_this.attr("id") == "email") {
                                if (!app.validateEmail(_this.val())) {
                                    app.notValid(this, window._formSFErrors.mail);
                                    _errors = true;
                                }
                            }
                            if (_this.val() === "" && !_this.hasClass('btn-group')) {
                                if (_formSwitcher.val() === "Sales Partnership") {
                                    if (_this.hasClass('contact-tnc')) {
                                        if (_this.find('.checker').length) {
                                            if (!_this.find('.checked').length) {
                                                app.notValid(this, window._formSFErrors.optin);
                                                _errors = true;
                                            }
                                        }
                                    } else {
                                        _errors = true;
                                        app.notValid(this, window._formSFErrors.empty);
                                    }
                                } else if (_formSwitcher.val() !== "Sales Partnership") {
                                    if (!_this.hasClass("sf-form-control-sales-partnership")) {
                                        if (_this.find('.checker').length) {
                                            if (!_this.find('.checked').length) {
                                                app.notValid(this, window._formSFErrors.optin);
                                                _errors = true;
                                            }
                                        } else {
                                            _errors = true;
                                            app.notValid(this, window._formSFErrors.empty);
                                        }
                                    }
                                }
                            }
                        });
                        //
                        if (!_errors) {
                            var formulaire = $(this);
                            var post_url = formulaire.attr('action');
                            var post_data = formulaire.serialize();

                            $.post(window.assystem_vars.asscorpo_ajax_url,
                                {
                                    action: "sendAjaxContact",
                                    _ajax_nonce: window.assystem_vars.asscorpo_nonce,
                                    data: post_data,
                                    dataType: "json"
                                }, function (result) {
                                    if (result.state == "error") {
                                        $(".alert-msg .wpcf7-response-output").html(result.msg);
                                        $(".alert-msg").addClass("active");
                                        $(".alert-msg").addClass("error");
                                        _overlay.removeClass('show');
                                    } else if (result.state == "success") {
                                        // Affichage du formulaire avec un effet
                                        $(form).fadeOut(800, function () {
                                            var _html = '<div class="wpcf7-mail-sent-ok"><div class="message-title">';
                                            _html += result.msg;
                                            _html += '</div></div>';
                                            form.html(_html).fadeIn().delay(2000);
                                            _overlay.removeClass('show').delay(3000);
                                        });
                                    }
                                }
                            );
                        } else {
                            _overlay.removeClass('show');
                        }
                        //
                        e.preventDefault();
                        return false;
                    });
                }
            },
            validateEmail: function (email) {
                var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
                return regex.test(email)
            },
            notValid: function (target, message) {
                var $target = $(target);
                $('.wpcf7-not-valid-tip', $target.parent()).remove();
                $('<span role="alert" class="wpcf7-not-valid-tip"></span>').text(message).appendTo($target.parent());

                var fadeOut = function (target) {
                    $(target).not(':hidden').animate({
                        opacity: 0
                    }, 'fast', function () {
                        $(this).css({'z-index': -100});
                    });
                };

                $target.on('mouseover', '.wpcf7-not-valid-tip', function () {
                    fadeOut(this);
                });

                $target.on('focus', ':input', function () {
                    fadeOut($('.wpcf7-not-valid-tip', $target));
                });
            },
            formGeneralError: function () {
                var elForm = $(".general-alert-error");
                if (elForm.length != 0) {
                    window.scrollTo({
                        top: ($('.general-alert-error').offset().top),
                        behavior: 'smooth'
                    });
                }
            },
            passwordStrength: function () {
                // Nothing
            },
            initChips: function () {
                if(('.filter-projects').length > 0 || ('.offers-filter-inner').length > 0 ) {
                    let _listGroupItem = $('.list-group-item');
                    let _tagWrapper = $('.tag-wrapper');
                    _listGroupItem.each(function() {
                        let _input = $(this).find('input');
                        _input.change(function() {
                            var _card   =   $(this).parents(".card").attr("id");
                            if(this.checked) {
                                if( $('#tag-'+this.id+'').length == 0 ) {
                                    let response = $('label[for="' + this.id + '"]').html();
                                    let ariaLabel   =   window.assystem_vars.closeFilter.replace("%s", response);
                                    _tagWrapper.append('<span class="tag-search visuel" id="tag-'+this.id+'">' + response + '<button type="button" aria-label="'+ariaLabel+'" class="close remove">x</button></span>');
                                }
                            } else {
                                if( $('#tag-' + this.id).length > 0 ) {
                                    $('#tag-' + this.id).remove();
                                } else if( $(".tag-search[data-collapse='"+_card+"'][data-code='"+this.value+"']").length > 0 ) {
                                    $(".tag-search[data-collapse='"+_card+"'][data-code='"+this.value+"']").remove();
                                }
                            }

                            let _remove = $('.tag-search.visuel .remove');
                            _remove.on('click', function() {
                                var _rm     =   $(this),
                                    _item   =   _rm.parent(),
                                    _cat    =   _item.data("collapse"),
                                    _id     =   _item.data("code");
                                $("#"+_cat).find(".styled-checkbox[value='"+_id+"']").prop({checked: false});
                                $(this).parent().css("display","none");
                            });

                        });
                    });

                    $("body").on('click', '.tag-search.visuel .remove', function() {
                        var _id             =  $(this).parent().attr('id');
                        var _need_remove    =  _id.replace('tag-',"");
                        $("#"+_need_remove).prop( "checked", false );
                        $(this).parent().remove();
                    });
                }
            },
            initPodcasts: function() {
                var _podcasts   =   $(".block-podcast");
                if( _podcasts.length > 0 ) {
                    _podcasts.find(".cta a").on("click", function(e) {
                        var _this   =   $(this),
                            _cnt    =   _this.parents(".cta"),
                            _target =   _this.data("target"),
                            _height =   _this.data("height"),
                            _html   =   '';
                        if( typeof(_height) == "undefined" ) {
                            _height =   190;
                        }
                        if( _target != "" ) {
                            _html   =   '<iframe src="'+_target+'" frameBorder="0" width="100%" height="'+_height+'px"></iframe>';
                            _cnt.html(_html).removeClass("cta");
                        }
                        e.preventDefault();
                        return false;
                    });
                }
                var _ctaPodcast = $(".listen-to-podcast");

                if( _ctaPodcast.length > 0 && _podcasts.length > 0 ) {
                    _ctaPodcast.on("click", function(e){
                        var _top    =   _podcasts.first().offset().top;
                        if ($(window).scrollTop() > 0) {
                            _top = _top - $("#masthead").outerHeight();
                        } else {
                            _top = _top - ($("#masthead").outerHeight() * 2);
                        }
                        window.scrollTo({
                            top: _top,
                            behavior: 'smooth'
                        });
                        _podcasts.first().find(".cta a").trigger("click");
                        e.preventDefault();
                        return false;
                    });
                }
            },
            initVideoBanner: function() {
                var _introVideoBloc =   $(".intro-video");
                if( _introVideoBloc.length > 0 ){
                    var _videoPlayer    =   _introVideoBloc.find("#player").find("video");
                    if( _videoPlayer.length > 0 ) {
                        _introVideoBloc.find(".video-control").on("click", function(e){
                            var _this   =   $(this),
                                _label  =   _this.attr("aria-label"),
                                _state  =   _this.data("state");
                            _this.attr("aria-label", _state);
                            _this.attr("data-state", _label);
                            if( _this.hasClass("paused") )  {
                                _videoPlayer[0].play();
                                _this.removeClass("paused");
                            } else {
                                _videoPlayer[0].pause();
                                _this.addClass("paused");
                            }
                        });
                    }
                }
            },
            initCollapseSearchBarV2: function () {
                $('#collapseFiltersCarrer').on('show.bs.collapse', function () {
                    $('#offers-filter-wrap').addClass('collapse-opened');
                });
                $('#collapseFiltersCarrer').on('hide.bs.collapse', function () {
                    $('#offers-filter-wrap').removeClass('collapse-opened');
                })
            },
        };
        app.init();
    });
})(jQuery);